import { Amplify } from "aws-amplify";
import { parseAmplifyConfig } from "aws-amplify/utils";
import awsconfig from "./aws-exports";

// The legacy aws-exports format maps to Amplify v6 with allowGuestAccess=false
// by default. Public (signed-out) visitors need guest Cognito credentials to
// presign private S3 media URLs, so we enable guest access explicitly. Without
// this, getUrl() throws NoCredentials and all signed media fails to load.
// This does NOT make the bucket public: the identity pool already permits
// unauthenticated identities, media stays behind signed URLs, and the unauth
// IAM role is scoped to s3:GetObject on media/* only.
const amplifyConfig = parseAmplifyConfig(awsconfig);

Amplify.configure(
  {
    ...amplifyConfig,
    Auth: {
      ...amplifyConfig.Auth,
      Cognito: {
        ...amplifyConfig.Auth?.Cognito,
        allowGuestAccess: true,
      },
    },
  },
  { ssr: true }
);
